import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';

export const BRANCH_BASE_FRAGMENT = gql`
  fragment BranchBaseFragment on Branch {
    id
    name
    organization {
          id
    }
    address {
      ...AddressFragment
    }
    offerSettings {
      id
    }
    missingInSource
  }
  ${ADDRESS_FRAGMENT}
`;
